import { pdfLabelSetRepository } from '@webapp/modules/vendor/data-access/repositories/PDFLabelSetRepository' // eslint-disable-line import/no-internal-modules
import { type PDFLabelSetConstructor } from '@webapp/modules/vendor/entities/PDFLabelSet' // eslint-disable-line import/no-internal-modules

/**
 * Resolve the initially-active PO PDF label set (BHV-032):
 * primary set if one exists → else first available set → else `null`
 * (empty state). `getPrimary()` answers `null` on the API's 404 —
 * a valid "no primary" state, not an error.
 */
export const getInitialPOPDFLabelSet =
  async (): Promise<PDFLabelSetConstructor | null> => {
    const [primary, availableSets] = await Promise.all([
      pdfLabelSetRepository.getPrimary(),
      pdfLabelSetRepository.list(),
    ])

    return primary ?? availableSets.data[0] ?? null
  }
